import { Col, Container, If, Input, Row, Space, Spacer, Text } from '@app/components'
import { IStore } from '@app/redux'
import { getThemeColors } from '@app/theme'
import { formatWalletAddress, toCurrency } from '@app/utils'
import { Button, Segmented } from 'antd'
import { CustomSelect } from 'collections/buy-and-sell/collections/custom-select'
import useLocked from 'libs/services/hooks/useLocked'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useAccount, useChainId } from 'wagmi'

import { WaitV2Icon } from '~public'

import { UnlockSummary } from '../unlock-summary'

export const Unlock: React.FC<{ isForDrawer?: boolean }> = ({ isForDrawer = false }) => {
  const { theme } = useSelector((state: IStore) => state)
  const COLORS = getThemeColors(theme.value)

  const tokenDecimals = 8
  const { address } = useAccount()
  const chainId = useChainId()

  const locked = Number(useLocked().value) / 10 ** tokenDecimals

  const [selectedAsset, setSelectedAsset] = useState<any>({
    id: '1',
    name: 'WAIT',
    icon: <WaitV2Icon style={{ height: 25 }} />,
    val: 'HEX',
  })
  const [unlockingTokens, setUnlockTokens] = useState(0)

  const ASSET_LIST = [
    {
      id: '1',
      name: chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 'eWAIT' : 'Wait',
      icon: <WaitV2Icon style={{ height: 25 }} />,
      val: 'WAIT',
    },
  ]

  const DISCOUNTS = [
    {
      value: 0,
      discount: chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 1 : 4,
    },
    {
      value: 1000,
      discount: chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 0.75 : 3,
    },
    {
      value: 10000,
      discount: chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 0.5 : 2,
    },
    {
      value: 100000,
      discount: chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 0.25 : 1,
    },
  ]

  const addy = () => {
    if (address != undefined) {
      return formatWalletAddress(address)
    }
  }

  const getSegmentedFontColor = (v) => {
    if (v === unlockingTokens) {
      return { color: COLORS.WHITE }
    } else return {} // Default font color
  }

  const getSegmentedOptions = () => {
    return DISCOUNTS.filter(function (i) {
      return i.value < locked
    }).map((item) => {
      const isActive = locked - item.value === unlockingTokens // Check active state
      return {
        label: (
          <Container
            padding="10px"
            style={{
              border: isActive ? `2px solid ${COLORS.PRIMARY}` : `1px solid ${COLORS.darkGrey}`, // Active border
              borderRadius: '8px', // Rounded corners
              cursor: 'pointer', // Change cursor to pointer
              backgroundColor: isActive ? COLORS.PRIMARY : COLORS.WHITE, // Highlight active option
              color: isActive ? COLORS.WHITE : COLORS.darkGrey, // Text color
              textAlign: 'center',
              transition: 'all 0.3s ease', // Smooth transition
            }}
          >
            <Text style={{ display: 'block', ...getSegmentedFontColor(locked - item.value) }}>
              {toCurrency(locked - item.value, false)}
            </Text>
            <Text style={getSegmentedFontColor(locked - item.value)}>
              Tier: {item.discount * (chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 4 : 1)}
            </Text>
          </Container>
        ),
        value: locked - item.value,
      }
    })
  }

  const calculateNewDiscountValue = () => {
    return DISCOUNTS.find((item) => locked - unlockingTokens === item.value)?.discount
  }

  const calculateCurrentDiscountValue = () => {
    return DISCOUNTS.find((item) => locked === item.value)?.discount
  }

  if (
    (chainId != parseInt(process.env.NEXT_PUBLIC_PULSECHAIN) &&
      chainId != parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN)) ||
    address == undefined
  ) {
    return (
      <Row>
        <Col span={24} md={24} lg={isForDrawer ? 24 : 12}>
          <Space direction="vertical">
            <Text strong>Please switch to PulseChain Mainnet or Ethereum Mainnet</Text>
          </Space>
        </Col>
      </Row>
    )
  }

  return (
    <Row>
      <Col span={24} md={24} lg={isForDrawer ? 24 : 12}>
        <Row>
          <Col style={{ width: '100%' }}>
            <Text>Select Asset</Text>
            <Spacer value={10} />
            <CustomSelect type="Asset" selected={selectedAsset} setSelected={setSelectedAsset} list={ASSET_LIST} />
          </Col>

          <Col style={{ width: '100%' }}>
            <Text>Locked Tokens</Text>
            <Spacer value={10} />
            <Input disabled defaultValue={toCurrency(0, false)} value={locked} />
          </Col>

          <If condition={locked != 0}>
            <Col style={{ width: '100%' }}>
              <Text>Unlock Tokens</Text>
              <Spacer value={10} />
              <Segmented
                style={{ backgroundColor: COLORS.baseBgColor }}
                size="small"
                block
                options={getSegmentedOptions()}
                onChange={(v) => setUnlockTokens(Number(v))}
                value={unlockingTokens}
              />
            </Col>
          </If>
        </Row>
        <Spacer />
        <Row>
          <Col style={{ width: '100%' }}>
            <Button block href="http://app.0xcoast.com/fees#holidayDiv">
              About Fee Tiers
            </Button>
          </Col>
        </Row>
      </Col>
      <Col span={24} md={24} lg={isForDrawer ? 24 : 12}>
        <UnlockSummary
          wallet={addy()}
          unlockingTokens={unlockingTokens}
          setUnlockingTokens={setUnlockTokens}
          lockedWait={locked}
          currentDiscount={calculateCurrentDiscountValue()}
          newDiscount={calculateNewDiscountValue()}
          asset={selectedAsset}
          chain={chainId}
          title={chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 'eWait' : 'Wait'}
        />
      </Col>
    </Row>
  )
}
